/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * RouteConstraintStartLocationDtoBase
 * auto generated base class for the model RouteConstraintStartLocationDtoModel.
 */
export const RouteConstraintStartLocationDtoModelBase = ModelBase
  .named('RouteConstraintStartLocationDto')
  .props({
    __typename: types.optional(types.literal("RouteConstraintStartLocationDto"), "RouteConstraintStartLocationDto"),
    id: types.union(types.undefined, types.integer),
    address: types.union(types.undefined, types.string),
    latitude: types.union(types.undefined, types.null, types.number),
    longitude: types.union(types.undefined, types.null, types.number),
    active: types.union(types.undefined, types.boolean),
    bestMatch: types.union(types.undefined, types.boolean),
    locationStatusId: types.union(types.undefined, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class RouteConstraintStartLocationDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get address() { return this.__attr(`address`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  get active() { return this.__attr(`active`) }
  get bestMatch() { return this.__attr(`bestMatch`) }
  get locationStatusId() { return this.__attr(`locationStatusId`) }
}
export function selectFromRouteConstraintStartLocationDto() {
  return new RouteConstraintStartLocationDtoModelSelector()
}

export const routeConstraintStartLocationDtoModelPrimitives = selectFromRouteConstraintStartLocationDto().address.latitude.longitude.active.bestMatch.locationStatusId
